import * as de from '@angular/common/locales/de';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { LOCALE_ID, NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MatomoConsentComponent } from 'src/app/matomo/matomo-consent.component';
import { OrganizationEditPageModule } from 'src/app/organization/organization-edit/organization-edit.page.module';

import { CoreModule } from './@core/core.module';
import { FilterPageModule } from 'src/app/filter/filter.page.module';
import { IonicConfig } from '@ionic/core';
import { SharedModule } from './@shared/shared.module';
import { hasSmallScreenLayout } from 'src/app/@core/pwa.service';

// --- Factories ---------------------------------------------------------------
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const getIonicConfig = (): IonicConfig => {
  const isSmallScreen = hasSmallScreenLayout();

  const config: IonicConfig = {
    animated: isSmallScreen,
    innerHTMLTemplatesEnabled: true,
    inputShims: isSmallScreen,
    rippleEffect: isSmallScreen,
    sanitizerEnabled: true,
    swipeBackEnabled: isSmallScreen,
    tabButtonLayout: isSmallScreen
      ? 'icon-top'
      : 'icon-start',
  };

  return config;
};

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent, MatomoConsentComponent],
  imports: [
    /**/ AppRoutingModule, // AppRoutingModule has to be imported first
    FilterPageModule,
    OrganizationEditPageModule,
    BrowserModule,
    CoreModule,
    IonicModule.forRoot(getIonicConfig()),
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
      },
    }),
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor() {
    registerLocaleData(de.default); // Then register the language
  }
}
